// Generated by CoffeeScript 1.9.1
var SeqCollection, _, tf, treeHelper;
_ = require("underscore");
SeqCollection = require("../model/SeqCollection");
module.exports = treeHelper = function treeHelper(msa) {
  this.msa = msa;
  return this;
};
tf = {
  loadTree: function loadTree(cb) {
    return this.msa.g["package"].loadPackages(["msa-tnt", "biojs-io-newick"], cb);
  },
  showTree: function showTree(newickStr) {
    var m, mt, newick, newickObj, nodes, sel, t, treeDiv;
    newick = this.require("biojs-io-newick");
    if (typeof newickStr === "string") {
      newickObj = newick.parse_newick(newickStr);
    } else {
      newickObj = newickStr;
    }
    mt = this.require("msa-tnt");
    sel = new mt.selections();
    treeDiv = document.createElement("div");
    this.msa.el.insertBefore(treeDiv, this.msa.el.childNodes[0]);
    console.log(this.msa.seqs.models);
    console.log(newickObj);
    nodes = mt.app({
      seqs: this.msa.seqs.toJSON(),
      tree: newickObj
    });
    console.log("nodes", nodes);
    t = new mt.adapters.tree({
      model: nodes,
      el: treeDiv,
      sel: sel
    });
    m = new mt.adapters.msa({
      model: nodes,
      sel: sel,
      msa: this.msa
    });
    _.each(nodes.models, function (e) {
      delete e.collection;
      return Object.setPrototypeOf(e, require("backbone-thin").Model.prototype);
    });
    this.msa.seqs.reset(nodes.models);
    return console.log(this.msa.seqs);
  },
  require: function (_require) {
    function require(_x) {
      return _require.apply(this, arguments);
    }
    require.toString = function () {
      return _require.toString();
    };
    return require;
  }(function (pkg) {
    return require(pkg);
  })
};
_.extend(treeHelper.prototype, tf);